import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./app/App";
import { applyTheme, readTheme } from "./data/themes";
import "@fontsource/space-grotesk/latin-500.css";
import "@fontsource/space-grotesk/latin-600.css";
import "@fontsource/dm-sans/latin-400.css";
import "@fontsource/dm-sans/latin-500.css";
import "@fontsource/ibm-plex-mono/latin-400.css";
import "./styles/tokens.css";
import "./styles/global.css";
import "./styles/sections.css";
import "./styles/pages.css";
import "./styles/navigation.css";
import "./styles/hero.css";
import "./styles/builds.css";
import "./styles/portrait.css";
import "./styles/about-focus.css";
import "./styles/motion.css";

applyTheme(readTheme());
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
